document.addEventListener("DOMContentLoaded", function() {
  const galleryList = document.querySelector('.product-gallery__media-list');

  let letterDisplay = null;
  if (galleryList) {
    letterDisplay = document.createElement('div');
    letterDisplay.className = 'select-letter-display';
    letterDisplay.style.cssText = `
      position: absolute;
      z-index: 999;
      left: 50%;
      top: 0%;
      transform: translateX(-50%);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
    `;
    galleryList.appendChild(letterDisplay);
  }

  function removeWhiteBackground(imageUrl, callback) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function() {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        if (data[i] > 240 && data[i+1] > 240 && data[i+2] > 240) {
          data[i+3] = 0;
        }
      }

      ctx.putImageData(imageData, 0, 0);
      callback(canvas.toDataURL());
    };
    img.src = imageUrl;
  }

  document.addEventListener("click", function(e) {
    const label = e.target.closest('.gs__product-option[data-child-name="select-letter"] .gs__option-upsell-label');
    if (!label || !letterDisplay) return;

    if (label.dataset.handled) return;
    label.dataset.handled = "true";
    setTimeout(() => delete label.dataset.handled, 0);

    const bgImage = getComputedStyle(label).backgroundImage;
    const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
    const imageUrl = match ? match[1] : null;
    if (!imageUrl) return;

    const isMobile = window.innerWidth <= 768;
    const imgSize = isMobile ? 100 : 150;

    const existingImg = Array.from(letterDisplay.children).find(img => img.dataset.src === imageUrl);

    if (existingImg) {
      letterDisplay.removeChild(existingImg);
    } else {
      removeWhiteBackground(imageUrl, function(newUrl) {
        const img = document.createElement('img');
        img.src = newUrl;
        img.dataset.src = imageUrl;
        img.style.width = imgSize + 'px';
        img.style.height = imgSize + 'px';
        img.style.margin = '0 -15px';
        img.style.objectFit = 'contain';
        letterDisplay.appendChild(img);
      });
    }
  });

  window.addEventListener("resize", function() {
    const isMobile = window.innerWidth <= 768;
    const imgSize = isMobile ? 100 : 150;
    if (letterDisplay) {
      Array.from(letterDisplay.children).forEach(img => {
        img.style.width = imgSize + 'px';
        img.style.height = imgSize + 'px';
      });
    }
  });
});
